import moment from 'moment';
import { T } from 'react-translator-component';

import { parseNotificationMessageType } from './notificationMessageType';
export interface Notification {
  addressCity: string;
  addressState: string;
  addressStreet: string;
  chargeBoxId: string;
  chargeBoxName: string;
  connectorErrorCode: string;
  connectorErrorMsg: string;
  connectorId: number;
  idTag: string;
  notificationPk: number;
  notificationTimestampDT: string;
  registrationStatus: string;
  transactionId: number;
  type:
    | 'TransactionEnded'
    | 'TransactionStarted'
    | 'StationBooted'
    | 'Connected'
    | 'Disconnected'
    | 'Avaialble'
    | 'Failure';
  userName: string;
  userPk: number;
}

export interface normalizedNotification {
  type: string;
  message: string;
  date: string;
}

export const parseNotificationsTimeline = (notificationList: Notification[]): normalizedNotification[] => {
  return notificationList.map((notification) => {
    return {
      type: notification.type,
      message: `${notification.chargeBoxName}: ${parseNotificationMessageType(notification.type)}. ${
        notification.userName ? `${T('User')}: ${notification.userName}` : ''
      }`,
      date: moment.utc(notification.notificationTimestampDT).local().format('DD/MM/YY HH:mm'),
    };
  });
};
